import { useAuth, useView } from '@10000/react'
import { assetUrl } from '../../utilities.js'
import { Button, Body, Box, H3, MadeByPodAndHive } from '../widgets'
import { useBackground, useShell, useStack } from '../layout'
import { SelectOrganisation, SelectTeam, SelectSquiz, SquizOptions } from '.'
import { Dashboard } from '../analytics'
import { Kiosk } from '../kiosk'
import { teamIsComplete } from '../onboarding'
import './Home.scss'

export const Home = ({ active }) => {
  const { user: { groups } } = useAuth()
  const { user: { name } = { }, company, myOrganisations, teams, subscription, currentSquizzes } = useView('tenant')
  const { results } = useView('results')
  const { push } = useStack()
  const canRunSquiz = teams.some(x => teamIsComplete(x)) && subscription.ends > Date.now()

  useShell({ active, mode: 'authenticated', headerBackground: 'black' })
  useBackground().set({ active, background: null })

  const startComponent = (myOrganisations.length > 1 && teams.length > 1)
    ? SelectOrganisation
    : teams.filter(x => teamIsComplete(x)).length > 1
      ? SelectTeam
       : SquizOptions

  return (
    <Box column className="home" justifyContent="space-between">
      <Box column gap={8} fullWidth>
        <H3 fullWidth align="left">Hi, {name}</H3>
        <Box className="desktop-only">
          <Body lineHeight="100%" alt weight={600} color="var(--grey)" size={16}>{company.name}</Body>
        </Box>
        {currentSquizzes.length > 0 &&
          <Box alignSelf="center">
            <Button onClick={() => push(SelectSquiz)}>
              {currentSquizzes.length} active Squiz{currentSquizzes.length > 1 && 'zes'}
            </Button>
          </Box>
        }
      </Box>
      <img src={assetUrl('gifs/head.gif')} alt="picasso head" />
      <Box column gap={16}>
        <Button onClick={() => push(startComponent)} disabled={!canRunSquiz}>
          Start a Squiz
        </Button>
        <Button onClick={() => push(Dashboard)} disabled={!results?.length}>
          See analytics
        </Button>
        {groups?.includes('kiosk') &&
          <Button fullWidth onClick={() => push(Kiosk)}>
            Kiosk mode
          </Button>
        }
      </Box>
      <MadeByPodAndHive className="desktop-only"/>
    </Box>
  )
}